// extracted by mini-css-extract-plugin
export default {"container":"lSVFS","player":"TrFDG","toolbar":"rcaTh","actions":"RpEP4","durationIcon":"F9dXd","actionIcon":"sOXe7"};